export default __webpack_public_path__ + "static/slp2x-313114be11f061c1952aacc27c85b2ff.png";